"use client";

import { VariantProps, cva } from "class-variance-authority";
import { useTranslation } from "next-i18next";
import { MultiPurposeParagraph } from "../Paragraph";
import styles from "./index.module.scss";

export type TagLabelVariantProps = VariantProps<typeof TagLabelVariants>;
const TagLabelVariants = cva(`  `, {
  variants: {
    layout: {
      default: `absolute z-10 bg-white px-4 py-2 top-6 h-fit`,
      gridRounded: ``,
      featured: "",
    },
  },
  defaultVariants: {
    layout: "default",
  },
});

export interface TagLabelProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    TagLabelVariantProps {
  highlight: any;
  label: any;
  color: any;
}

function formatLayoutTypeLabel(label: string): string {
  if (!label) return label;
  return label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
}

function resolveLabelText(label: any, t: (key: string) => string) {
  const rawLabel = label === "default" ? "recipe" : label;
  if (rawLabel === "recipe") return t("recipe");
  if (typeof rawLabel === "string") return formatLayoutTypeLabel(rawLabel);
  return rawLabel;
}

export function TagLabel({ highlight, label, color, layout }: TagLabelProps) {
  const { t } = useTranslation("common");
  const displayLabel = resolveLabelText(label, t);
  const isGridRounded = layout === "gridRounded";

  if (isGridRounded) {
    return (
      <div
        style={{ backgroundColor: highlight?.color?.hex }}
        className={styles.gridRoundedLabel}
      >
        <MultiPurposeParagraph
          type="label"
          data={displayLabel}
          color={{ hex: "#ffffff" }}
        />
      </div>
    );
  }

  return (
    <div
      style={{ backgroundColor: `${highlight?.color.hex}` }}
      className={`${TagLabelVariants({ layout })}`}
    >
      <MultiPurposeParagraph data={displayLabel} color={color?.color} />
    </div>
  );
}
